export const LogoutIcon = () => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.1748 5.67018C7.4073 2.97018 8.7948 1.86768 11.8323 1.86768H11.9298C15.2823 1.86768 16.6248 3.21018 16.6248 6.56268V11.4527C16.6248 14.8052 15.2823 16.1477 11.9298 16.1477H11.8323C8.8173 16.1477 7.4298 15.0602 7.1823 12.4052"
        stroke="#F6FCFF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.7498 9H3.21484"
        stroke="#F6FCFF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.8875 6.4873L2.375 8.99981L4.8875 11.5123"
        stroke="#F6FCFF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
